import {
  ROUTES,
  ONBOARDING_ROUTES,
  SMART_CHARGING_ROUTES,
  SELF_ONBOARDING_ROUTES,
  SITE_AUTHENTICATION_ROUTES,
} from "./routes";

export const TARIFF_PATHS = [
  ROUTES.PV_SETUP,
  ROUTES.WALLBOX,
  ROUTES.BATTERY_SETUP,
  ROUTES.ANNUAL_GRID_SUPPLY,
  ROUTES.SMART_METER,
  ROUTES.CALCULATED_SAVINGS,
  ROUTES.TARIF,
];

export const ORDER_PATHS = [
  ROUTES.YOUR_NAME,
  ROUTES.CONTACT_INFORMATION,
  ROUTES.ADDRESS,
  ROUTES.TECHNICAL_DETAILS,

  ROUTES.CONTRACT_CHANGE,
  ROUTES.CURRENT_SUPPLIER,
  ROUTES.DATE_OF_CONTRACT_START,

  ROUTES.PAYMENT_DETAILS,
  ROUTES.FEED_IN_OFFER,
  ROUTES.CONTRACT_SUMMARY,

  ROUTES.CONCLUSION,
];

export const ERROR_PATHS = [ROUTES.ERROR];

export const TARIFF_AND_ORDER_PATHS = [...TARIFF_PATHS, ...ORDER_PATHS];

export const ONBOARDING_PATHS = [
  ONBOARDING_ROUTES.ONBOARDING_SYSTEM,
  ONBOARDING_ROUTES.ONBOARDING_CONNECTED_DEVICES,
  ONBOARDING_ROUTES.ONBOARDING_ERROR_RETRY,
];

export const SMART_CHARGING_COMPATIBILITY_PATHS = [
  SMART_CHARGING_ROUTES.COMPATIBILITY,
  SMART_CHARGING_ROUTES.MODEL,
  SMART_CHARGING_ROUTES.TERMS,
  SMART_CHARGING_ROUTES.COMPATIBILITY_SUCCESS,
  SMART_CHARGING_ROUTES.MANUFACTURER_SEARCH,
  SMART_CHARGING_ROUTES.MODEL_SEARCH,
  SMART_CHARGING_ROUTES.STATUS,
];

export const SMART_CHARGING_ONBOARDING_PATHS = [
  SMART_CHARGING_ROUTES.START,
  SMART_CHARGING_ROUTES.INTRO,
  SMART_CHARGING_ROUTES.CONNECT_CONFIRM,
  SMART_CHARGING_ROUTES.CONNECTING,
  SMART_CHARGING_ROUTES.CONNECTING_SUCCESS,
  SMART_CHARGING_ROUTES.CONNECTING_ERROR,
  SMART_CHARGING_ROUTES.ONBOARDING_SLIDER,
];

export const SMART_CHARGING_PATHS = [
  ...SMART_CHARGING_COMPATIBILITY_PATHS,
  ...SMART_CHARGING_ONBOARDING_PATHS,
];

export const SITE_AUTHENTICATION_PATHS = [
  SITE_AUTHENTICATION_ROUTES.START,
  SITE_AUTHENTICATION_ROUTES.SUCCESS,
  SITE_AUTHENTICATION_ROUTES.FAILED,
  SITE_AUTHENTICATION_ROUTES.AUTHENTICATION_CALLBACK,
];

export const SELF_ONBOARDING_PATHS = [SELF_ONBOARDING_ROUTES.COMPATIBILITY];

export const SELF_ONBOARDING_ACCESS_PATHS = [
  SELF_ONBOARDING_ROUTES.ACCESS,
  SELF_ONBOARDING_ROUTES.ACCESS_FAILED,
  SELF_ONBOARDING_ROUTES.ACCESS_SUCCESS,
  SELF_ONBOARDING_ROUTES.AUTHENTICATION_CALLBACK,
];
